// MainPlatformsStep4.js
import { Box } from "@mui/material";
import MainContentReUse from "./MainContentReUse";
import CheckboxesComponent from "./CheckboxesComponent";
import TextFieldWithHeading from "./TextFieldWithHeading";
import { useState } from "react";
import api from "../../config/axios";

const mainPlatformsCheckboxes = [
  { label: "Instagram" },
  { label: "Tik Tok" },
  { label: "YouTube" },
  { label: "X / Twitter" },
  { label: "Twitch" },
  { label: "Spotify" },
  { label: "Podcasting" },
  { label: "LinkedIn" },
  { label: "Newsletter" },
  { label: "Other" },
];

function MainPlatformsStep4({ onSuccess }) {
  // We'll track chosen platforms in an array
  const [checkedPlatforms, setCheckedPlatforms] = useState([]);
  const [handles, setHandles] = useState("");
  const [stats, setStats] = useState("");

  // For the checkboxes, we can pass a callback to CheckboxesComponent OR we do it ourselves manually.
  // A simpler approach is to define a custom CheckboxesComponent that calls back, or we can do a quick fix:

  const handleTogglePlatform = (platformLabel) => {
    setCheckedPlatforms((prev) =>
      prev.includes(platformLabel)
        ? prev.filter((p) => p !== platformLabel)
        : [...prev, platformLabel]
    );
  };

  // We'll call /api/auth/platforms on next
  const handleNext = async () => {
    try {
      await api.put("/auth/platforms", {
        mainPlatforms: checkedPlatforms,
        handles,
        stats,
      });
      onSuccess();
    } catch (err) {
      console.error("Platforms update error:", err);
      alert(err?.response?.data?.message || "Error updating platforms");
    }
  };

  return (
    <MainContentReUse
      primaryButton={{ exist: true, text: "Next Step" }}
      onClick={handleNext}
      smallDivider={false}
      headLogoBelowPadding="0px"
    >
      <Box>
        <CheckboxesComponent
          primaryText="Main Platforms"
          secondaryText="Select the platforms you primarily use"
          checkBoxes={mainPlatformsCheckboxes}
          // We'll pass a custom prop to handle selection
          value={checkedPlatforms}
          onChange={handleTogglePlatform}
        />
        {/* Next fields */}
        <TextFieldWithHeading
          heading="Handle(s)"
          placeholder="@username1, @username2"
          value={handles}
          onChange={(e) => setHandles(e.target.value)}
        />
        <TextFieldWithHeading
          heading="Significant contracts, users, stats?"
          placeholder="Describe your significant achievements..."
          multiline
          rows={8}
          value={stats}
          onChange={(e) => setStats(e.target.value)}
        />
      </Box>
    </MainContentReUse>
  );
}

export default MainPlatformsStep4;
